import {
  ExploreOutlined,
  FolderOutlined,
  GroupsOutlined,
  LocalPolice,
  MicOutlined,
  PublicOutlined,
  Speed,
} from '@context365/icons'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { isEmpty } from 'lodash'
import { useSelector } from 'react-redux'
import { ROLE } from '~/constants/roles'
import useAuth from '~/hooks/useAuth'
import { getTier } from '~/selectors/auth'

const isDiscoverBlocked = ({ tier, role, contact }) =>
  ['Standard'].includes(tier) || (role === ROLE.CFN && !contact.isCFNAllocator)

const userNavItems = [
  {
    label: 'Dashboard',
    path: '/',
    exact: true,
    icon: <Speed />,
  },
  {
    label: 'Discover',
    path: '/discover',
    icon: <ExploreOutlined />,
    isActive: (match, location) => {
      if (!match) return false
      return !location.pathname.startsWith('/discover/mandates')
    },
    blocked: isDiscoverBlocked,
    visibleOnMobile: ({ flags }) => flags.mobileDiscover,
  },
  {
    label: 'My Campaigns',
    path: '/campaigns',
    icon: <FolderOutlined />,
    visibleOnMobile: () => true,
  },
  {
    label: 'Community',
    path: '/community',
    icon: <GroupsOutlined />,
    visible: ({ flags }) => flags.communityModule,
    visibleOnMobile: () => true,
  },
  {
    label: 'Events',
    path: '/summits',
    icon: <PublicOutlined />,
    visibleOnMobile: ({ flags }) => flags.mobileSummits,
  },
  {
    label: 'Subscription',
    path: '/settings/subscriptions',
    icon: <LocalPolice className="text-gold-100" />,
    visible: ({ flags }) => flags.freeStarterProTiers,
  },
]

const guestNavItems = [
  {
    label: 'Presentations',
    path: '/community/presentations',
    icon: <MicOutlined />,
    visible: ({ flags }) => flags.showNewEvent,
  },
]

export default function useNavItems() {
  const tier = useSelector(getTier)
  const { role, contact } = useAuth()
  const flags = useFlags()

  const options = { tier, role, contact, flags }

  const navItems = role === 'Guest Presentation' ? guestNavItems : userNavItems
  return navItems
    .filter(({ visible }) => !visible || (!isEmpty(flags) && visible(options)))
    .map(({ blocked, visibleOnMobile, ...navItem }) => ({
      ...navItem,
      blocked: blocked?.(options),
      visibleOnMobile: visibleOnMobile?.(options),
    }))
}
